module.exports = __webpack_public_path__ + "static/img/interpretive-writing02.6ef1d4d.jpg";


//////////////////
// WEBPACK FOOTER
// ./src/assets/images/pages/content-development/interpretive-writing02.jpg
// module id = 998
// module chunks = 0